'use strict';
(function () {
  if (!customElements.get('timer-component')) {

		class Timer extends HTMLElement {
			constructor() {
				super();
				this.loop = this.dataset.loop === "true";
				this.endDate = this.loop
					? this.getMidnightTomorrow()
					: this.dataset.endDate;
			}

			connectedCallback() {
				this.startTimer(this.endDate);
			}

			getMidnightTomorrow() {
				let t = new Date();
				t.setDate(t.getDate() + 1);
				t.setHours(0, 0, 0, 0);
				return t;
			}

			startTimer(endTimeStr) {
				const endTime = new Date(endTimeStr).getTime();

				const interval = setInterval(() => {
					const now = new Date().getTime();
					let distance = endTime - now;

					if (distance < 0) {
						if (this.loop) {
							endTime = this.getMidnightTomorrow().getTime();
							distance = endTime - now;
						} else {
							clearInterval(interval);
							this.querySelector(".days").textContent = 0;
							this.querySelector(".hours").textContent = 0;
							this.querySelector(".minutes").textContent = 0;
							this.querySelector(".seconds").textContent = 0;
							return;
						}
					}

					const days = Math.floor(distance / (1000 * 60 * 60 * 24));
					const hours = Math.floor(
						(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
					);
					const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					const seconds = Math.floor((distance % (1000 * 60)) / 1000);

					if (days == 0) {
						this.querySelector(".days").parentNode.style.display = "none";
					} else {
						this.querySelector(".days").parentNode.style.display = "inline-block";
						this.querySelector(".days").textContent = days;
					}
					this.querySelector(".hours").textContent = hours;
					this.querySelector(".minutes").textContent = minutes;
					this.querySelector(".seconds").textContent = seconds;
				}, 1000);
			}
		}

		customElements.define("timer-component", Timer);
	}
})();
